'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.RestaurantTypes = void 0;
(function (RestaurantTypes) {
    RestaurantTypes["DINEOUT"] = "WIDGET_TYPE_IMAGE_RESTAURANT_WITH_DO";
    RestaurantTypes["FOOD"] = "WIDGET_TYPE_IMAGE_RESTAURANT_WITH_FOOD";
    RestaurantTypes["DINEOUT_AND_FOOD"] = "WIDGET_TYPE_IMAGE_RESTAURANT_WITH_DO_AND_FOOD";
})(exports.RestaurantTypes || (exports.RestaurantTypes = {}));
const SERVICEABILITY_TYPES = {
    SERVICEABLE: "SERVICEABLE",
    NON_SERVICEABLE: "NON_SERVICEABLE",
    SERVICEABLE_WITH_BANNER: "SERVICEABLE_WITH_BANNER",
};

exports.SERVICEABILITY_TYPES = SERVICEABILITY_TYPES;
//# sourceMappingURL=type.js.map
